import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import MetricForm from '../MetricForm';

function MetricEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <MetricForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </MetricForm>
    </Edit>
  );
}

export default MetricEdit;
